import React, { useCallback, useEffect, useRef, useState } from "react";
import { useReactToPrint } from "react-to-print";
import { Input, Modal, ModalBody, ModalHeader, Spinner } from "reactstrap";
import exportExcel from "../../helpers/utils/exportExcel";
import { toast } from "react-toastify";

const PrintContent = React.forwardRef(({ dataSections }, ref) => (
  <div
    style={{
      position: "absolute",
      top: "-9999px",
      left: "-9999px",
    }}
  >
    <div
      ref={ref}
      style={{
        padding: "40px 80px 40px 80px",
        backgroundColor: "white",
      }}
    >
      {dataSections.map((section, i) => {
        if (!section.data || section.data.length === 0) return null;

        const keys = Object.keys(section.data[0]);

        return (
          <div
            key={i}
            style={{
              marginBottom: "30px",
              pageBreakInside: "avoid",
              pageBreakAfter: i < dataSections.length - 1 ? "always" : "auto",
              padding: "20px 0",
            }}><div style={{ height: "40px" }} />
            <h2>{section.title}</h2>
            <table
              style={{
                width: "100%",
                borderCollapse: "collapse",
                border: "1px solid black",
              }}>
              <thead>
                <tr>
                  {keys.map((key) => (
                    <th
                      key={key}
                      style={{
                        border: "1px solid black",
                        padding: "8px",
                        wordBreak: "break-word",
                        whiteSpace: "normal", // <-- ini penting agar teks turun baris
                        fontSize: "10px", // kecilkan teks jika perlu
                      }}>
                      {key}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {section.data.map((item, idx) => (
                  <tr key={idx}>
                    {keys.map((key) => (
                      <td
                        key={key}
                        style={{
                          border: "1px solid black",
                          padding: "8px",
                          wordBreak: "break-word",
                          whiteSpace: "normal", // <-- ini penting agar teks turun baris
                          fontSize: "10px", // kecilkan teks jika perlu
                        }}>
                        {item[key]}
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        );
      })}
    </div>
  </div>
));

PrintContent.displayName = "PrintContent";

const ExporMultiDoc = ({ data = [] }) => {
  const printRef = useRef(null);
  const onBeforeGetContentResolve = useRef(null);
  const [loadingPrint, setLoadingPrint] = useState(false);
  const [modal, setModal] = useState(false);
  const [headerData, setHeaderData] = useState([]);
  const [dataDocument, setDataDocument] = useState([]);

  const reactToPrintContent = useCallback(() => {
    return printRef.current;
  }, [printRef]);

  const handleAfterPrint = useCallback(() => {
    // tslint:disable-line no-console
  }, []);

  const handleBeforePrint = useCallback(() => {
    // tslint:disable-line no-console
  }, []);

  const handleOnBeforeGetContent = useCallback(() => {
    setLoadingPrint(true);

    return new Promise((resolve) => {
      onBeforeGetContentResolve.current = resolve;

      setTimeout(() => {
        setLoadingPrint(false);
        resolve();
      }, 2000);
    });
  }, [setLoadingPrint]);

  const handlePrint = useReactToPrint({
    content: reactToPrintContent,
    documentTitle: "Task",
    onBeforeGetContent: handleOnBeforeGetContent,
    onBeforePrint: handleBeforePrint,
    onAfterPrint: handleAfterPrint,
    removeAfterPrint: true,
  });

  const toggle = useCallback(() => {
    if (modal) {
      setModal(false);
    } else {
      if (data.length === 0) {
        toast.error("Ceklis dahulu data yang ingin di print", {
          autoClose: 3000,
        });
        setModal(false);
      } else {
        setModal(true);
      }
    }
  }, [modal, data]);

  useEffect(() => {
    const keysSet = new Set();

    data.forEach((section) => {
      section.data.forEach((item) => {
        Object.keys(item).forEach((key) => keysSet.add(key));
      });
    });

    const uniqueKeys = Array.from(keysSet);
    const editKeys = uniqueKeys.map((key) => ({
      id: `${Date.now()}-${Math.floor(Math.random() * 1000)}`,
      key: key,
      label: key,
      isSelected: true,
    }));
    setHeaderData(editKeys);
  }, [data]);

  useEffect(() => {
    const finalData = data.map((section) => ({
      title: section.title,
      data: section.data.map((item) => {
        const newItem = {};
        headerData.forEach(({ key, label, isSelected }) => {
          if (isSelected && key in item) {
            newItem[label] = item[key];
          }
        });
        return newItem;
      }),
    }));

    setDataDocument(finalData);
  }, [headerData, data]);


  return (
    <>
      <button type="button" className="btn btn-success" onClick={toggle}>
        <i className="ri-file-download-line me-1 align-bottom fs-14"></i> Export
      </button>
      <Modal id="showModalDetail" isOpen={modal} centered size="md">
        <ModalHeader className="bg-light p-3" toggle={toggle}>
          Pengaturan Export
        </ModalHeader>
        <ModalBody>
          <div className="row p-3">
          {(headerData || []).map((header, idx) => {
            return (
              <div
                key={idx}
                className={
                  "col-lg-6 d-flex align-items-center justify-content-center mb-1 gap-1 form-check form-switch form-switch-custom form-switch-success"
                }>
                <Input
                  className={
                    "form-check-input checked-all checked-method-all check-" +
                    header.id +
                    idx
                  }
                  type="checkbox"
                  role="switch"
                  id={"check-" + header.id + idx}
                  checked={header.isSelected}
                  disabled={
                    header.isSelected &&
                    headerData.filter((data) => data.isSelected).length === 1
                  }
                  onChange={(e) => {
                    const newDataTabel = [...headerData];
                    newDataTabel[idx].isSelected =
                      !newDataTabel[idx].isSelected;
                    setHeaderData(newDataTabel);
                  }} />
                <div className="fs-12 text-uppercase">
                  <input
                    value={header.label}
                    onChange={(e) => {
                      setHeaderData((prevData) =>
                        prevData.map((itm) =>
                          itm.id === header.id
                            ? { ...itm, label: e.target.value }
                            : itm
                        )
                      );
                    }}/>
                </div>
              </div>
            );
          })}
          </div>
        </ModalBody>
        <div className="modal-footer">
          <div className="hstack gap-2 justify-content-end">
            <button type="button" className="btn btn-light" onClick={toggle}>
              Close
            </button>

            <button
              type="submit"
              className="btn btn-info"
              onClick={handlePrint}>
              Pdf&nbsp;
              {loadingPrint ? (
                <Spinner
                  size="sm"
                  className="flex-shrink-0 ms-2"
                  role="status" ></Spinner>
              ) : (
                ""
              )}
              {/* <Spinner
                size="sm"
                className="flex-shrink-0 ms-2"
                role="status"></Spinner> */}
            </button>
            <button
              type="submit"
              className="btn btn-info"
              onClick={() => {
                exportExcel(dataDocument);
              }}>
              Excel
            </button>
          </div>
        </div>
      </Modal>
      <PrintContent ref={printRef} dataSections={dataDocument} />
    </>
  );
};

export default ExporMultiDoc;
